import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const items = [
    "Suitability Reports",
    "Cash Flow Modelling",
    "Annual Reviews",
    "Platform Administration",
    "Pension Research",
    "LOA Tracking",
    "Client Onboarding",
    "Tax Wrapper Analysis",
  ];
  return (
    <section className="bg-verdigris py-8 md:py-10 border-y border-petrol/20" data-testid="marquee-section">
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="marquee-item text-parchment text-4xl md:text-6xl italic px-8 md:px-12">
              {t}
            </span>
            <span className="text-petrol/70 text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
